import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";

const AirViewPage = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    {
      label: "Consumption Month",
      previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
      requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
        data?.editValue?.consumptionPeriod?.year || "—"
      }`,
    },
    {
      label: "Origin",
      previous: data?.origin || "—",
      requested: data?.editValue?.origin || "—",
    },
    {
      label: "Destination",
      previous: data?.destination || "—",
      requested: data?.editValue?.destination || "—",
    },
    {
      label: "Freight Load",
      previous:
        data?.freightLoad?.value && data?.freightLoad?.unit
          ? `${data.freightLoad.value} ${data.freightLoad.unit}`
          : "—",
      requested:
        data?.editValue?.freightLoad?.value &&
        data?.editValue?.freightLoad?.unit
          ? `${data.editValue.freightLoad.value} ${data.editValue.freightLoad.unit}`
          : "—",
    },
    {
      label: "Distance Covered",
      previous:
        data?.distanceCovered?.value && data?.distanceCovered?.unit
          ? `${data.distanceCovered.value} ${data.distanceCovered.unit}`
          : "—",
      requested:
        data?.editValue?.distanceCovered?.value &&
        data?.editValue?.distanceCovered?.unit
          ? `${data.editValue.distanceCovered.value} ${data.editValue.distanceCovered.unit}`
          : "—",
    },

    {
      label: "Remark",
      previous: data?.remark || "—",
      requested: data?.editValue?.remark || "—",
    },
    {
      label: "Transportation Type",
      previous: data?.transportationType || "—",
      requested: data?.editValue?.transportationType || "—",
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Air Transportation"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default AirViewPage;
